import { IMedicationsListFilters } from '~/services/api/medications/types';

const initialValues: IMedicationsListFilters = {
  startDate: '',
  endDate: '',
};

export default initialValues;
